import { type Response, sendGet, sendPost } from '../hooks/use-fetch'
import { CommentParentType, type NewCommentValues, type UpdateCommentValues, type CommentModel, type NewPlanOrgTaskCommentValues, type RecentCommentsResponseModel } from '../models/Comment'

export async function GetComments (parentId: number, parentType: CommentParentType): Promise<Response<CommentModel[]>> {
  let url = ''

  switch (parentType) {
    case CommentParentType.PlanOrganizationTask:
      url = `Comment/GetCommentsForPlanOrgTask?planOrganizationTaskId=${parentId}`
      break
    case CommentParentType.Comment:
      url = 'Comment/GetComments'
      break
  }
  return await sendGet(url)
}

export async function GetCommentDetails (commentId: string): Promise<Response<CommentModel>> {
  return await sendGet(`Comment/GetCommentDetails?commentId=${commentId}`)
}

export async function AddComment (comment: NewCommentValues): Promise<Response> {
  let planOrgTaskComment: NewPlanOrgTaskCommentValues

  switch (comment.parentType) {
    case CommentParentType.PlanOrganizationTask:
      planOrgTaskComment = {
        planOrganizationTaskId: comment.parentId,
        commentText: comment.commentText,
        taggedUserEmails: comment.taggedUserEmails
      }
      return await sendPost('Comment/AddPlanOrgTaskComment', planOrgTaskComment)
    case CommentParentType.Comment:
      return await sendPost('Comment/AddComment', comment)
  }
}

export async function UpdateComment (comment: UpdateCommentValues): Promise<Response> {
  return await sendPost('Comment/UpdateComment', comment)
}

export async function DeleteComment (commentId: number): Promise<Response> {
  return await sendPost(`Comment/DeleteComment?commentId=${commentId}`, {})
}

export async function GetRecentCommentsForAnnualPlan (annualPlanId: number): Promise<Response<RecentCommentsResponseModel>> {
  return await sendGet(`Comment/GetRecentCommentsForAnnualPlan?annualPlanId=${annualPlanId}`)
}
